import type { ConversationSortOption } from "@noa/api-core";
import { useState } from "react";
import { useDebounce } from "./useDebounce";

export const CONVERSATION_SORT_OPTIONS: { key: ConversationSortOption; labelKey: string }[] = [
  { key: "new-old", labelKey: "conversation:sort.newOld" },
  { key: "old-new", labelKey: "conversation:sort.oldNew" },
  { key: "az", labelKey: "conversation:sort.az" },
  { key: "za", labelKey: "conversation:sort.za" },
];

export function useConversationHistoryFilters() {
  const [showDeleted, setShowDeleted] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState<ConversationSortOption>("new-old");
  const debouncedSearch = useDebounce(search, 300);

  return {
    showDeleted,
    setShowDeleted,
    search,
    setSearch,
    debouncedSearch,
    sort,
    setSort,
    listParams: {
      deleted: showDeleted,
      filter: debouncedSearch || undefined,
      sort,
    },
  };
}
